import { useEffect, useState, type FC } from 'react';
import { Moon, Sun } from 'lucide-react';
import {
  applyTheme,
  readPreference,
  resolveTheme,
  savePreference,
  watchSystemTheme,
  type ThemeMode,
} from '../theme';
import { t } from '../i18n';

/**
 * Light/dark almashtirgich.
 *
 * Boshlang'ich holat `auto` — Telegram mijozining mavzusiga ergashadi.
 * Foydalanuvchi bir marta bossa, tanlovi saqlanadi va `auto` dan chiqadi.
 */
export const ThemeToggle: FC = () => {
  const [mode, setMode] = useState<ThemeMode>(() =>
    resolveTheme(readPreference()),
  );

  useEffect(() => watchSystemTheme(setMode), []);

  useEffect(() => {
    applyTheme(mode);
  }, [mode]);

  const toggle = () => {
    const next: ThemeMode = mode === 'dark' ? 'light' : 'dark';
    savePreference(next);
    setMode(next);
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-label={
        mode === 'dark'
          ? t('Yorugʻ rejimga oʻtish')
          : t('Qorongʻi rejimga oʻtish')
      }
      title={mode === 'dark' ? t('Yorugʻ rejim') : t('Qorongʻi rejim')}
    >
      {mode === 'dark' ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
};
